import { apiGet } from '@/network/api/apiAdapter'

import type { BaseRes } from '@/network/api/print/type'

/**
 * 前端运行时公开配置（scope=PUBLIC，无需认证）
 * 由 apigate 配置中心下发，key 经 apiAdapter 转为 camelCase
 */
export interface WebOfficialPublicConfig {
  ossBaseUrl?: string
  siteName?: string
  siteLogo?: string
  supportEmail?: string
  supportPhone?: string
  miniProgramQrcodeUrl?: string
  wechatQrcodeUrl?: string
  /** 上传规则（由 third_party_configs.web_official_config 下发） */
  upload_max_file_size_gb?: number
  upload_supported_formats?: string
  upload_recommended_format?: string
  upload_fullcolor_formats?: string
  [key: string]: any
}

export interface PublicConfigDto {
  service: string
  config: WebOfficialPublicConfig
  fetchedAt: string
}

/** 获取 web_official 前端公开配置 */
export const fetchWebOfficialPublicConfigApi = (service = 'web_official') =>
  apiGet<BaseRes<PublicConfigDto>>(`config/public?service=${encodeURIComponent(service)}`)
